module.exports = __webpack_public_path__ + "img/logo_login.75340604.png";